import React from "react";
import GeneralSettingComponent from "./general-setting.component";

const GeneralSettingContainer = () => {
  return <GeneralSettingComponent />;
};

export default GeneralSettingContainer;
